import { render } from "./PixKeyClaimRequestConfirm.vue?vue&type=template&id=1c36513c"
import script from "./PixKeyClaimRequestConfirm.vue?vue&type=script&lang=js"
export * from "./PixKeyClaimRequestConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__